var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "absolute z-20 rounded-md shadow-lg bg-white",
      class: _vm.flowDirection,
      attrs: {
        role: "menu",
        "aria-orientation": "vertical",
        "aria-labelledby": "menu-button",
        tabindex: "-1",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-64 p-3 flex flex-col justify-items-center items-center leading-tight text-sm tracking-tighter",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center border-b border-gray-300 pb-3 w-full space-y-2 leading-tight",
            },
            [
              _c("CircleWithInitials", {
                staticClass: "mr-2",
                attrs: { title: _vm.project.name, id: _vm.project.id },
              }),
              _c("div", { staticClass: "font-bold text-lg" }, [
                _vm._v(_vm._s(_vm.project.name)),
              ]),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col items-center justify-between py-1 border-b border-gray-300 w-full",
            },
            [
              _c(
                "div",
                { staticClass: "flex items-center justify-between w-full" },
                [
                  _c("span", { staticClass: "font-semibold" }, [
                    _vm._v("Manager"),
                  ]),
                  _vm.project.manager
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex space-x-1 items-center justify-end px-1 py-1 rounded-full bg-blue-200 leading-tight h-7",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "flex h-full" },
                            [
                              _vm._t(
                                "image",
                                function () {
                                  return [
                                    _c("S3Image", {
                                      staticClass:
                                        "inline-block rounded-full object-cover object-center h-[98%] aspect-square hover:border hover:border-primary",
                                      attrs: {
                                        s3FileKey:
                                          _vm.project.manager.user.avatar,
                                      },
                                    }),
                                  ]
                                },
                                { image: _vm.project.manager.user.avatar }
                              ),
                            ],
                            2
                          ),
                          _c("div", { staticClass: "flex justify-end" }, [
                            _vm._v(" " + _vm._s(_vm.managerFullname) + " "),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex items-center justify-between w-full mt-5",
                },
                [
                  _c("span", { staticClass: "font-semibold" }, [
                    _vm._v("Contractors"),
                  ]),
                  _c("div", { staticClass: "flex h-7" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center h-full" },
                      [
                        _vm._l(
                          _vm.contractors.slice(0, 3),
                          function (contractor) {
                            return _c(
                              "div",
                              { key: contractor.id, staticClass: "h-full" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "rounded-full transform hover:scale-125 -m-1 h-full",
                                  },
                                  [
                                    contractor.user.avatar
                                      ? [
                                          _vm._t(
                                            "image",
                                            function () {
                                              return [
                                                _c("S3Image", {
                                                  staticClass:
                                                    "inline-block rounded-full object-cover object-center h-full aspect-square hover:border hover:border-primary",
                                                  attrs: {
                                                    s3FileKey:
                                                      contractor.user.avatar,
                                                  },
                                                }),
                                              ]
                                            },
                                            { image: contractor.user.avatar }
                                          ),
                                        ]
                                      : [
                                          _vm._t("initial", function () {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "flex rounded-full object-cover object-center h-full w-7 hover:border hover:border-primary bg-primary justify-center items-center",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-xs leading-none tracking-tighter font-semibold text-white w-full",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            contractor.user.given_name
                                                              .trimStart()[0]
                                                              .toUpperCase()
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            contractor.user.family_name
                                                              .trimStart()[0]
                                                              .toUpperCase()
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          }),
                                        ],
                                  ],
                                  2
                                ),
                              ]
                            )
                          }
                        ),
                        _vm.contractors.length > 3
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex h-8 w-8 rounded-full border-gray-200 border transform hover:scale-125 bg-blue-400 -mt-1.5 -ml-1",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-center items-center h-full w-full",
                                  },
                                  [
                                    _c("PlusIcon", {
                                      staticClass: "fill-current w-1.5 h-1.5",
                                    }),
                                    _c("p", {}, [
                                      _vm._v(
                                        _vm._s(_vm.contractors.length - 3)
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass:
                "flex flex-col items-center justify-between pt-3 w-full",
            },
            [
              _c("div", { staticClass: "flex w-full" }, [
                _c("span", { staticClass: "w-24 text-gray-500" }, [
                  _vm._v("Activities"),
                ]),
                _c("div", { staticClass: "font-semibold" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.project.project_activities_aggregate.aggregate.count
                      ) +
                      " "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex w-full" }, [
                _c("span", { staticClass: "w-24 text-gray-500" }, [
                  _vm._v("Budget"),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "font-semibold tracking-tighter leading-tight",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.min_budget) +
                        " - " +
                        _vm._s(_vm.max_budget) +
                        " "
                    ),
                  ]
                ),
              ]),
              _c("div", { staticClass: "flex w-full" }, [
                _c("span", { staticClass: "w-24 text-gray-500" }, [
                  _vm._v("Start Date"),
                ]),
                _c("div", { staticClass: "font-semibold" }, [
                  _vm._v(" " + _vm._s(_vm.project.start_date) + " "),
                ]),
              ]),
              _c("div", { staticClass: "flex w-full" }, [
                _c("span", { staticClass: "w-24 text-gray-500" }, [
                  _vm._v("End Date"),
                ]),
                _c("div", { staticClass: "font-semibold" }, [
                  _vm._v(" " + _vm._s(_vm.project.end_date) + " "),
                ]),
              ]),
              _vm._m(0),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "flex w-full" }, [
      _c("span", { staticClass: "w-24 text-gray-500" }, [
        _vm._v("Hours Spent"),
      ]),
      _c("div", { staticClass: "font-semibold" }, [_vm._v(" 84 Hrs ")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }